import { useIntl } from 'react-intl';

export const useFormatDateTime = () => {
    const { formatDate, formatTime } = useIntl();
    const formatDateTime = (date: string) => {
        if (Number.isNaN(new Date(date).getTime())) {
            return '';
        }
        return `${formatDate(date)} ${formatTime(date)}`;
    };
    return { formatDateTime };
};
